package com.havn.app.core.localization

import com.havn.app.core.navigation.HavnDestination

fun HavnDestination.localizedTitle(strings: HavnStrings): String = when (this) {
    HavnDestination.Auth -> strings.navAuth
    HavnDestination.Dashboard -> strings.navToday
    HavnDestination.Properties -> strings.navProperties
    HavnDestination.OpenHouses -> strings.navOpenHouses
    HavnDestination.Clients -> strings.clientsTitle
    HavnDestination.Leads -> strings.navLeads
    HavnDestination.FollowUps -> strings.navFollowUps
    HavnDestination.Files -> "My Files"
    HavnDestination.Reports -> strings.navReports
    HavnDestination.Tasks -> strings.navTasks
    HavnDestination.Analytics -> strings.navAnalytics
    HavnDestination.Agency -> strings.navAgency
    HavnDestination.Settings -> strings.navSettings
}

fun HavnDestination.localizedShortLabel(strings: HavnStrings): String = when (this) {
    HavnDestination.Auth -> strings.navAuth
    HavnDestination.Dashboard -> strings.navToday
    HavnDestination.Properties -> strings.navProperties
    HavnDestination.OpenHouses -> strings.navTours
    HavnDestination.Clients -> strings.clientsTitle
    HavnDestination.Leads -> strings.navLeads
    HavnDestination.FollowUps -> strings.navFollow
    HavnDestination.Files -> "Files"
    HavnDestination.Reports -> strings.navReports
    HavnDestination.Tasks -> strings.navTasks
    HavnDestination.Analytics -> strings.navAnalytics
    HavnDestination.Agency -> strings.navAgency
    HavnDestination.Settings -> strings.navSettings
}
